module.exports = __webpack_public_path__ + "static/media/Blou_5.952d3fe9.png";